import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { MerchantLifecycleRepository } from '@app/domain/ports/tpv/merchant-lifecycle.repository';
import { UpdateMerchantRequest } from '@app/data/dtos/tpv/merchant-update.dto';

/**
 * Mock del ciclo de vida de comercios para pruebas sin backend (toggle tpvUseMocks).
 * Simula latencia y siempre resuelve con éxito.
 */
@Injectable()
export class MerchantLifecycleMockDataSource extends MerchantLifecycleRepository {
  override updateMerchant(
    _externalIdMerchant: string,
    _payload: UpdateMerchantRequest,
  ): Observable<void> {
    return of(void 0).pipe(delay(400));
  }

  override deleteMerchant(_externalIdMerchant: string): Observable<void> {
    return of(void 0).pipe(delay(400));
  }

  override activateMerchant(_externalIdMerchant: string): Observable<Record<string, unknown> | null> {
    return of<Record<string, unknown>>({
      id_merchant_memphis: 12345,
      token_activation: 'MOCK-TOKEN-1234',
    }).pipe(delay(400));
  }
}
